import discretionaryService from "./impl/discretionaryService";
import discretionaryServiceMock from "./impl/discretionaryServiceMock";

const discretionaryServiceInterface = {
    getInvestmentProposalAllClient(applicationConfig, urlParam) {
        if (process.env.REACT_APP_MOCK) {
            return discretionaryServiceMock.getInvestmentProposalAllClient(applicationConfig);
        }
        return discretionaryService.getInvestmentProposalAllClient(applicationConfig, urlParam);
    },
    saveInvestmentProposalScreenCapture(applicationConfig, formDataPdf) {
        if (process.env.REACT_APP_MOCK) {
            return discretionaryServiceMock.saveInvestmentProposalScreenCapture(applicationConfig, formDataPdf);
        }
        return discretionaryService.saveInvestmentProposalScreenCapture(applicationConfig, formDataPdf);
    },
    sendInvestmentProposalScreenCaptureFailure(applicationConfig) {
        if (process.env.REACT_APP_MOCK) {
            return discretionaryServiceMock.sendInvestmentProposalScreenCaptureFailure(applicationConfig);
        }
        return discretionaryService.sendInvestmentProposalScreenCaptureFailure(applicationConfig);
    }
};

export default discretionaryServiceInterface;
